import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from './spinner.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(private spinnerService: SpinnerService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // 1 - IF THE REQUEST IS TOWARDS OUR ASSETS FOLDER THEN EXIT IMMEDIATELY...
    if (request.url.startsWith('/assets/')) return next.handle(request);

    // 2 - FOR OUTGOING REQUESTS DISPLAY OUR LOADING INDICATOR...
    this.spinnerService.show();

    // 3 - GET TOKEN FROM STORAGE / SERVICE / WHEREVER YOU KEEP IT...
    const token = localStorage.getItem('auth_token');

    // 4 - CLONE THE REQUEST AND APPEND THE TOKEN IF IT EXISTS...
    const authRequest = token
      ? request.clone({ setHeaders: { "Authorization": `Bearer ${token}` } })
      : request;

    // 5 - SEND THE MODIFIED REQUEST...
    return next.handle(authRequest).pipe(
      finalize(() => { this.spinnerService.hide(); })
    );
  }
}
